/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiService } from '@shared/services';
import { IReportService } from '@/shared/src/interfaces/services';
import {
  ReportChartRequestModel,
  ReportChartResponseModel,
  ReportContentSessionPaginationRequestModel,
  ReportContentSessionPaginationResponseModel,
  ReportDownloadResponseModel,
  ReportStudySubjectModel,
  ReportTimeSessionModel
} from '@/shared/src/models/Report';

export class ReportService extends ApiService implements IReportService {
  constructor() {
    super('/report/parent');
  }

  /* ContentSession */

  getContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportContentSessionPaginationResponseModel> {
    const cancelToken = this.getCancelToken('getParentContentSessionToken');
    return this.get('/contentSession/get', { cancelToken, params });
  }

  getOrgContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportContentSessionPaginationResponseModel> {
    throw new Error('Method not implemented.');
  }

  getParentContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportContentSessionPaginationResponseModel> {
    throw new Error('Method not implemented.');
  }

  getOrgContentSessionById(
    id: number,
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportContentSessionPaginationResponseModel> {
    throw new Error('Method not implemented.');
  }

  getParentContentSessionById(
    id: number,
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportContentSessionPaginationResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportDownloadResponseModel> {
    return this.get('/contentSession/download', { params });
  }

  downloadOrgContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentContentSession(
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadOrgContentSessionById(
    id: number,
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentContentSessionById(
    id: number,
    params: ReportContentSessionPaginationRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  /* TimeSession */

  getTimeSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportTimeSessionModel>> {
    const cancelToken = this.getCancelToken('getParentTimeSessionToken');
    return this.get('/timeSession/get', { cancelToken, params });
  }

  getOrgTimeSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportTimeSessionModel>> {
    throw new Error('Method not implemented.');
  }

  getParentTimeSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportTimeSessionModel>> {
    throw new Error('Method not implemented.');
  }

  getOrgTimeSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportTimeSessionModel>> {
    throw new Error('Method not implemented.');
  }

  getParentTimeSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportTimeSessionModel>> {
    throw new Error('Method not implemented.');
  }

  downloadTimeSession(params: ReportChartRequestModel): Promise<ReportDownloadResponseModel> {
    return this.get('/timeSession/download', { params });
  }

  downloadOrgTimeSession(params: ReportChartRequestModel): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentTimeSession(params: ReportChartRequestModel): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadOrgTimeSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentTimeSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  /* StudySubjectSession */

  getStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportStudySubjectModel>> {
    const cancelToken = this.getCancelToken('getParentStudySubjectSessionToken');
    return this.get('/studySubjectSession/get', { cancelToken, params });
  }

  getOrgStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportStudySubjectModel>> {
    throw new Error('Method not implemented.');
  }

  getParentStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportStudySubjectModel>> {
    throw new Error('Method not implemented.');
  }

  getOrgStudySubjectSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportStudySubjectModel>> {
    throw new Error('Method not implemented.');
  }

  getParentStudySubjectSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportChartResponseModel<ReportStudySubjectModel>> {
    throw new Error('Method not implemented.');
  }

  downloadStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    return this.get('/studySubjectSession/download', { params });
  }

  downloadOrgStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentStudySubjectSession(
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadOrgStudySubjectSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }

  downloadParentStudySubjectSessionById(
    id: number,
    params: ReportChartRequestModel
  ): Promise<ReportDownloadResponseModel> {
    throw new Error('Method not implemented.');
  }
}
